import React, { useEffect, useRef } from 'react';
import './predictbbb_DetailPanel.css';
import PanelNavbar from './PanelNavbar';
import predictbbb_logo from '../assets/predictbbb_logo.png';
import predictbbb_side_panel_bg from '../assets/predictbbb_side_panel_bg.png';
import predictbbb_panel_center_image from '../assets/predictbbb_panel_center_image.png';
import LanternLabs3 from '../assets/LanternLabs3.png';
import predictbbb_UI_image from '../assets/predictbbb_UI_image.png';

const PredictBBBDetailPanel = ({ isOpen, onClose, sectionData }) => {
    const nextSectionRef = useRef(null);
    const contentRef = useRef(null);

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
            if (contentRef.current) {
                contentRef.current.scrollTop = 0;
            }
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [isOpen]);

    return (
        <div className={`detail-panel-overlay ${isOpen ? 'open' : ''}`} onClick={onClose}>
            <div
                ref={contentRef}
                className={`detail-panel-content ${isOpen ? 'open' : ''}`}
                onClick={(e) => e.stopPropagation()}
            >
                <PanelNavbar onClose={onClose} logo={predictbbb_logo} />
                <div className="panel-container">
                    <div
                        className="panel-hero-bg"
                        style={{
                            backgroundImage: `url(${predictbbb_side_panel_bg})`,
                        }}
                    ></div>
                    <div className="panel-body">
                        <h1 className="panel-main-title">Predict any molecule’s brain permeability</h1>
                        <p className="panel-description-text">
                            Does your small molecule cross the Blood-Brain Barrier? Ask predict BBB - an advanced AI module within Lantern Labs that predicts with 94% accuracy whether drug candidates can penetrate the blood–brain barrier, a critical challenge in developing therapies for CNS disorders.
                        </p>
                        <button className="panel-try-btn" onClick={() => window.open('https://predictbbb.ai', '_blank')}>
                            <span className="panel-try-btn-text">Try now</span>
                        </button>
                    </div>
                    <div className="panel-center-image-container">
                        <img
                            src={predictbbb_panel_center_image}
                            alt="Predict BBB Analysis"
                            className="panel-center-image"
                        />
                    </div>

                    <div className="panel-next-section" ref={nextSectionRef}>
                        <div className="section-title-group">
                            <h2 className="section-title-large">Predict BBB penetration</h2>
                            <div className="accuracy-label-container">
                                <div className="accuracy-line"></div>
                                <div className="accuracy-ellipse"></div>
                                <span className="accuracy-text">with 94% accuracy</span>
                            </div>
                        </div>

                        <div className="section-description-rich">
                            <p>
                                <span className="text-italic-medium">Predict BBB</span>
                                <span> is Lantern Labs’ AI-powered module designed to streamline and strengthen early decision-making in CNS drug development. By analyzing molecular structure, physiochemical properties, and thousands of curated features, Predict BBB provides a fast and reliable assessment of a compound’s likelihood to cross the blood–brain barrier.</span>
                            </p>

                            <p className="description-spacer"></p>

                            <p>
                                <span>Using a combination of classical machine learning and deep neural networks—optimized into a high-performing ensemble—Predict BBB achieves </span>
                                <span className="text-medium">94% accuracy</span>
                                <span>, </span>
                                <span className="text-medium">95% sensitivity</span>
                                <span>, and </span>
                                <span className="text-medium">89% specificity</span>
                                <span> on the industry-standard Therapeutic Data Commons benchmark.</span>
                            </p>

                            <p className="description-spacer"></p>

                            <p>
                                With Predict BBB, researchers can quickly prioritize viable CNS candidates, reduce costly downstream failures, and uncover new therapeutic opportunities with greater confidence.
                            </p>
                        </div>
                    </div>

                    <div className="panel-demo-section">
                        {/* Decorative Background Elements */}
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-1" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-2" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-3" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-4" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-5" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-6" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-7" />
                        <img src={LanternLabs3} alt="" className="demo-bg-decor decor-8" />

                        <div className="demo-content-wrapper">
                            <div className="demo-text-box">
                                <h2 className="demo-title">
                                    <span className="demo-title-medium">See Predict BBB in action </span>
                                    <span className="demo-title-light">— try the demo with your own molecule. </span>
                                    <br />
                                    <span className="demo-title-light">No sign up required.</span>
                                </h2>
                            </div>

                            <div className="demo-symbol-container">
                                <div className="demo-vertical-line"></div>
                                <div className="demo-symbol-ellipse"></div>
                            </div>

                            <div className="demo-image-container">
                                <img
                                    src={predictbbb_UI_image}
                                    alt="Predict BBB Demo Interface"
                                    className="demo-ui-image"
                                />                                <a
                                    href="https://predictbbb.ai"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="demo-try-btn"
                                    style={{ textDecoration: 'none' }}
                                >
                                    <span className="demo-try-btn-text">Try now</span>
                                </a>                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PredictBBBDetailPanel;
